import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { Button, Loader, Select, SelectOption, UserIcon } from "@mwi/ui";
import { setStep } from "slices/booking";
import { useGetPractitionerAvailabilityQuery } from "api";

type Inputs = {
  practitioner_contact_uuid: string;
};

const BookingFlowStep2a = (): JSX.Element => {
  const dispatch = useDispatch();

  const { patients, registeredSite, vetSite } = useSelector(
    (state: RootState) => ({
      patients: state.bookingFlow.formState.patients,
      registeredSite: state.auth.registered_site,
      vetSite: state.bookingFlow.formState.vet_site_uuid,
    }),
  );

  const {
    isLoading,
    data: practitionerAvailability,
    isFetching: fetchingPractitionerAvailability,
    isError: practitionerAvailabilityError,
  } = useGetPractitionerAvailabilityQuery({
    reasons: patients?.map((p) => p?.reason_uuid) ?? [],
    patients: patients?.map((p) => p.patient_uuid) ?? [],
    location_uuid: vetSite ? vetSite : (registeredSite?.id ?? ""),
  });

  const {
    watch,
    control,
    getValues,
    formState: { errors },
  } = useForm<Inputs>({
    defaultValues: {
      practitioner_contact_uuid: "false",
    },
  });

  const continueClicked = () => {
    const preferredPractitioner =
      practitionerAvailability?.find(
        (p) => p.contactUuid === getValues("practitioner_contact_uuid"),
      ) || null;

    dispatch(
      setStep({
        step: "3",
        preferredPractitioner,
      }),
    );
  };

  return (
    <>
      {isLoading && (
        <div className="grid h-full place-content-center">
          <Loader />
        </div>
      )}

      {!isLoading && (
        <>
          <div className="mb-8">
            <h2 className="text-4xl font-bold leading-[43px]">
              Is there a specific vet you'd like to see?
            </h2>
          </div>
          <div className="mb-[100px]">
            <form className="flex flex-col gap-4">
              <Select
                control={control}
                onChange={console.log}
                prefixIcon={<UserIcon />}
                placeholder="Preferred Vet"
                emptyStateErrorMessage="Any"
                name="practitioner_contact_uuid"
                disabled={practitionerAvailabilityError}
                loading={fetchingPractitionerAvailability}
                size="large"
              >
                <SelectOption value="false">No preference</SelectOption>
                {practitionerAvailability?.map((practitioner) => (
                  <SelectOption
                    key={practitioner.contactUuid}
                    value={practitioner.contactUuid}
                  >
                    {practitioner.firstName} {practitioner.lastName}
                  </SelectOption>
                ))}
              </Select>
            </form>
          </div>

          <Button
            block
            disabled={watch("practitioner_contact_uuid") == null}
            onClick={continueClicked}
            className="mb-[100px]"
          >
            Continue
          </Button>
        </>
      )}
    </>
  );
};

export default BookingFlowStep2a;
